import React from 'react';

const SectionTransition = ({ from, to }) => {
  // Helper to resolve tailwind-like color names to actual hex values from tailwind.config.js
  const colors = {
    'background': '#FCFCFC',
    'surface': '#F7F7FC',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#F7F7FC',
    'surface-container': '#F7F7FC',
    'surface-container-high': '#EBECFE',
    'surface-container-highest': '#D9DBE9',
  };

  const fromColor = colors[from] || from;
  const toColor = colors[to] || to;

  return (
    <div
      className="w-full h-[48px]"
      style={{
        background: `linear-gradient(to bottom, ${fromColor}, ${toColor})`
      }}
    />
  );
};

export default SectionTransition;


